import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartItemsModel, UserModel, UpsellItemsModel } from '../../core/models/ShoppingCart.model';
import { ShoppingService } from '../../core/services/shopping.service';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { Route, ActivatedRoute } from '@angular/router';
import { HelperService } from '../../core/services/helper.service';
import { appVariables, appMessages, appRoles } from '../../core/constants/Common.constant';
import { Constants } from '../../core/constants/constants';

import { Response, Headers, RequestOptions, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { forEach } from '@angular/router/src/utils/collection';
import { debug } from 'util';
import { Title } from '@angular/platform-browser';

import { overLimitCartDetails } from '../../../app/core/constants/Common.constant'
import { ConfirmDialogService } from '../../core/services/confirm-dialog.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
  })
export class CartComponent implements OnInit {
  user = new UserModel();
  fromLocal: UserModel;
  TotalQuantity = 0;
  CartSubtotal: number;
  ShippingMessage: string;
  ShippingCharge: number;
  Token: string;
  ImageUrl: string;
  BackToPageUrl: string;
  PromoCodeDisplay = { 'Message': '', 'class': 'redcolor' };
  CartItemsList: CartItemsModel[];
  PromoCode = '';
  ShowDiscount = false;
  ErroMessage = [];
  CartItemsList1 = [];
  loading = false;
  headers: Headers;
  cartQuantityLimit = overLimitCartDetails;
  promoCodeApplied: boolean = false;

  accountID: number;
  token: string;
  quantity: number = 1;
  UpsellItemsList: UpsellItemsModel[];

  RedirectProductURL: string;
  RedirectProductdetailURL: string;
  FADBaseUrl: string;
  DigitalProductNote: string;
  
  enableProductLimitMsg: Object = {}
  cartLimitMessage: string = overLimitCartDetails.message();
  // Titlelength: string;
  isDisabled: boolean;

  isLTI:string;
  isLTIProductChekoutMsg: string;
  InvalidPromocode: boolean = false;

  constructor(private shoppingService: ShoppingService, private router: Router, private confirmDialogService: ConfirmDialogService, 
    private helperService: HelperService, private activatedRoute: ActivatedRoute, private http: Http, private titleService: Title) {
    this.ImageUrl = environment.imageUrl;
    // this.headers = new Headers();
    // this.headers.append('Content-Type', 'application/json');
    // this.headers.append('appId', '5');
    // this.headers.append('token', '');
    this.titleService.setTitle('Shopping Cart | F.A. Davis');
  }
  
  loadItems() {
    this.shoppingService.GetCartItemsFromAPI(this.helperService.getFromLocalStorage(appVariables.promoCode),
      this.helperService.getFromLocalStorage(appVariables.cartGUID))
      .subscribe(
        (response) => {
          this.TotalQuantity = 0;
          this.CartSubtotal = 0;
          this.ShippingCharge = 0;
          if (response.Data) {

            //   console.log(response.Data);

            this.shoppingService.setCartItems(response.Data);
            //    this.shoppingService.setCartItems(response.DataFrequentlyProductList);
            if (localStorage.getItem(appVariables.promoCode) && response.Data.length > 0) {
              this.PromoCodeDisplay = { 'Message': '', 'class': 'redcolor' };
              this.PromoCodeDisplay.Message = 'Promotion code has been applied to your purchase'
              this.PromoCodeDisplay.class = 'greencolor promocodemessage';
              this.PromoCode = localStorage.getItem(appVariables.promoCode);
            }
          }
          if (response.DataFrequentlyProductList != null) {
            this.UpsellItemsList = response.DataFrequentlyProductList;
            // console.log(this.UpsellItemsList);
            //  this.Titlelength = 'Psychiatric Mental Health Nursing Success This product is currently out of stock and will backorder Psychiatric Mental Health Nursing Success This product is currently out of stock and will backorder'
          }
          this.isDisabled = (response && response.Message && response.Message != '') || this.isDisabled;
          if (this.isDisabled) {
            this.PromoCodeDisplay = { 'Message': '', 'class': 'redcolor' };
            this.ErroMessage.push(response.Message);
          }
        },
        (error) => { }
    );
 }
  oncustomcheck(Quantity) {
    return !isNaN(Quantity);
  }
  OnContinueShopping() {
    this.helperService.backToSite(this.BackToPageUrl);
  }
  OnProceedToCheckout() {
    if (this.helperService.getFromLocalStorage(appVariables.displaySection) === 'LogOut') {
      this.helperService.setToLocalStorage(appVariables.displaySection, '');
    }
  //FAD-1129
    //Check existing products
    this.fromLocal = this.helperService.getUserFromLocalStorage();
    let userRole = (this.fromLocal['AccountID'] != null) ? this.fromLocal.Role.toLowerCase().trim() : "";//FAD-1208 changes
    if (this.fromLocal['AccountID'] != null)
    {
      this.shoppingService.validateIfProductassociatedWithAccount(this.helperService.getFromLocalStorage(appVariables.cartGUID)).subscribe(
        (response) => {
          if(response.Data != null && response.Data== true)
          {
            this.confirmDialogService.confirmThis("You already have digital access to this title. Would you still like to continue to purchase?", () => {
              this.router.navigate(['../checkout'], { relativeTo: this.activatedRoute });
            }, function () {

            })

          }
          else{
            this.router.navigate(['../checkout'], { relativeTo: this.activatedRoute });
          }
        },
        (error) => {
          this.HandleError(error);
        }
      );
    }
    else {
      this.router.navigate(['../checkout'], { relativeTo: this.activatedRoute });
    }
    //popup to continue
    this.PromoCodeDisplay = { 'Message': '', 'class': 'redcolor' };
    
  }

  OnPromoCodeRemove(){
    this.promoCodeApplied = false;
    this.PromoCode = '';
    this.PromoCodeDisplay.Message = '';
    this.shoppingService.GetCartItemsFromAPI(this.PromoCode, this.helperService.getFromLocalStorage(appVariables.cartGUID))
      .subscribe(
        (response) => {
          this.shoppingService.setCartItems(response.Data);
          this.promoCodeApplied=false;
          this.helperService.setToLocalStorage(appVariables.promoCode, this.PromoCode);
        },
        (error) => {
          this.HandleError(error);

        }
      ); 
  }
  OnPromoCodeClick(PromoCode: string) {
    this.clear();//FAD-1360
    this.InvalidPromocode = false;
    localStorage.setItem(appVariables.promoCode, '');
    if(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(PromoCode)){
      this.PromoCodeDisplay.Message=`This promo code does not exist.`;
      this.InvalidPromocode = true;
      let Iscartwithdiscount = this.CartItemsList.findIndex(x=>x.DoShowDiscount == true);
        if(this.CartItemsList != null && Iscartwithdiscount != null && Iscartwithdiscount != -1)
        {
        PromoCode = '';
        }
        else{
        return false;
        }
    }
    this.shoppingService.GetCartItemsFromAPI(PromoCode, this.helperService.getFromLocalStorage(appVariables.cartGUID))
      .subscribe(
        (response) => {
          if (response.Data && response.Data.length > 0) {
            this.PromoCodeDisplay.Message = this.InvalidPromocode == false ?  response.Data[0]['PromoCodeMessage'] : this.PromoCodeDisplay.Message;
            if (this.PromoCodeDisplay.Message === appVariables.PromoCodeDisplayMessage) {
              localStorage.setItem(appVariables.promoCode, this.PromoCode);
              this.PromoCodeDisplay.class = 'greencolor promocodemessage';
              this.promoCodeApplied = true;
            } else {
              localStorage.setItem(appVariables.promoCode, '');
              this.PromoCodeDisplay.class = 'redcolor promocodemessage';
            }
            // this.PromoCode = '';
          }

          this.shoppingService.setCartItems(response.Data);
        },
        (error) => {
          this.HandleError(error);

        }
      );
  }
 
  ngOnInit() {
    this.PromoCode=this.helperService.getFromLocalStorage(appVariables.promoCode);
    if (this.PromoCode && this.PromoCode.trim() !== '') {
      this.promoCodeApplied = true;
      } else {
      this.promoCodeApplied = false;
      }
    //  this.uploadFileToActivity();

    // tslint:disable-next-line:max-line-length
    // this.CartItemsList1 = [{ 'ImageUrl': 'https://uatsecurewebcms.fadavis.com/images/thumbnail/978-0-8036-2955-4.jpg',     'RemoveImageUrl': 'https://uatsecurewebcms.fadavis.com/images/thumbnail//images/Btn_Remove.jpg',     'WebTitle': 'Sports Nutrition for Health Professionals - <span class=\'accesstypecolor\'>Student Access</span> ',     'ProductID': 11459, 'ISBN13': 'PLS2955', 'ListPrice': 71.95, 'strListPrice': '71.95', 'DoShowDiscount': false,      'DiscountPercent': 20, 'NetPrice': 71.95, 'strNetPrice': '71.95', 'IsDigitalProduct': true, 'Quantity': 1, 'OrderSubTotal': 71.95, 'strOrderSubTotal': '71.95', 'AppId': 2, 'FulfillmentClass': 'PRE', 'CanCartCheckout': true, 'PromoCodeMessage': '', 'CartSubtotal': '316.85', 'FullISBN13': 'ISBN-13: PLS2955', 'TaxAmount': 0.0, 'PromoCodeAmount': null, 'ProductTypeFormat': 'Print Book', 'PromoCode': null, 'ListPriceSubTotal': 71.95 }, { 'ImageUrl': 'https://uatsecurewebcms.fadavis.com/images/thumbnail/978-0-8036-2955-4.jpg', 'RemoveImageUrl': 'https://uatsecurewebcms.fadavis.com/images/thumbnail//images/Btn_Remove.jpg', 'WebTitle': 'Sports Nutrition for Health Professionals', 'ProductID': 9227, 'ISBN13': '2955-4', 'ListPrice': 95.95, 'strListPrice': '95.95', 'DoShowDiscount': false, 'DiscountPercent': 20, 'NetPrice': 95.95, 'strNetPrice': '95.95', 'IsDigitalProduct': false, 'Quantity': 1, 'OrderSubTotal': 95.95, 'strOrderSubTotal': '95.95', 'AppId': 5, 'FulfillmentClass': 'BU ', 'CanCartCheckout': true, 'PromoCodeMessage': '', 'CartSubtotal': '316.85', 'FullISBN13': 'ISBN-13: 978-0-8036-2955-4', 'TaxAmount': 0.0, 'PromoCodeAmount': null, 'ProductTypeFormat': 'Print Book', 'PromoCode': null, 'ListPriceSubTotal': 167.90 }, { 'ImageUrl': 'https://uatsecurewebcms.fadavis.com/images/thumbnail/978-0-8036-1904-3.jpg', 'RemoveImageUrl': 'https://uatsecurewebcms.fadavis.com/images/thumbnail//images/Btn_Remove.jpg', 'WebTitle': 'Wound Healing', 'ProductID': 5583, 'ISBN13': '1904-3', 'ListPrice': 148.95, 'strListPrice': '148.95', 'DoShowDiscount': false, 'DiscountPercent': 20, 'NetPrice': 148.95, 'strNetPrice': '148.95', 'IsDigitalProduct': false, 'Quantity': 1, 'OrderSubTotal': 148.95, 'strOrderSubTotal': '148.95', 'AppId': 5, 'FulfillmentClass': 'BU ', 'CanCartCheckout': true, 'PromoCodeMessage': '', 'CartSubtotal': '316.85', 'FullISBN13': 'ISBN-13: 978-0-8036-1904-3', 'TaxAmount': 0.0, 'PromoCodeAmount': null, 'ProductTypeFormat': 'Print Book', 'PromoCode': null, 'ListPriceSubTotal': 316.85 }, { 'ImageUrl': 'https://uatsecurewebcms.fadavis.com/images/thumbnail/978-0-8036-2955-4.jpg', 'RemoveImageUrl': 'https://uatsecurewebcms.fadavis.com/images/thumbnail//images/Btn_Remove.jpg', 'WebTitle': 'Sports Nutrition for Health Professionals - <span class=\'accesstypecolor\'>Student Access</span> ', 'ProductID': 11459, 'ISBN13': 'PLS2955', 'ListPrice': 71.95, 'strListPrice': '71.95', 'DoShowDiscount': false, 'DiscountPercent': 20, 'NetPrice': 71.95, 'strNetPrice': '71.95', 'IsDigitalProduct': true, 'Quantity': 1, 'OrderSubTotal': 71.95, 'strOrderSubTotal': '71.95', 'AppId': 2, 'FulfillmentClass': 'PRE', 'CanCartCheckout': true, 'PromoCodeMessage': '', 'CartSubtotal': '316.85', 'FullISBN13': 'ISBN-13: PLS2955', 'TaxAmount': 0.0, 'PromoCodeAmount': null, 'ProductTypeFormat': 'Print Book', 'PromoCode': null, 'ListPriceSubTotal': 71.95 }, { 'ImageUrl': 'https://uatsecurewebcms.fadavis.com/images/thumbnail/978-0-8036-2955-4.jpg', 'RemoveImageUrl': 'https://uatsecurewebcms.fadavis.com/images/thumbnail//images/Btn_Remove.jpg', 'WebTitle': 'Sports Nutrition for Health Professionals', 'ProductID': 9227, 'ISBN13': '2955-4', 'ListPrice': 95.95, 'strListPrice': '95.95', 'DoShowDiscount': false, 'DiscountPercent': 20, 'NetPrice': 95.95, 'strNetPrice': '95.95', 'IsDigitalProduct': false, 'Quantity': 1, 'OrderSubTotal': 95.95, 'strOrderSubTotal': '95.95', 'AppId': 5, 'FulfillmentClass': 'BU ', 'CanCartCheckout': true, 'PromoCodeMessage': '', 'CartSubtotal': '316.85', 'FullISBN13': 'ISBN-13: 978-0-8036-2955-4', 'TaxAmount': 0.0, 'PromoCodeAmount': null, 'ProductTypeFormat': 'Print Book', 'PromoCode': null, 'ListPriceSubTotal': 167.90 }, { 'ImageUrl': 'https://uatsecurewebcms.fadavis.com/images/thumbnail/978-0-8036-1904-3.jpg', 'RemoveImageUrl': 'https://uatsecurewebcms.fadavis.com/images/thumbnail//images/Btn_Remove.jpg', 'WebTitle': 'Wound Healing', 'ProductID': 5583, 'ISBN13': '1904-3', 'ListPrice': 148.95, 'strListPrice': '148.95', 'DoShowDiscount': false, 'DiscountPercent': 20, 'NetPrice': 148.95, 'strNetPrice': '148.95', 'IsDigitalProduct': false, 'Quantity': 1, 'OrderSubTotal': 148.95, 'strOrderSubTotal': '148.95', 'AppId': 5, 'FulfillmentClass': 'BU ', 'CanCartCheckout': true, 'PromoCodeMessage': '', 'CartSubtotal': '316.85', 'FullISBN13': 'ISBN-13: 978-0-8036-1904-3', 'TaxAmount': 0.0, 'PromoCodeAmount': null, 'ProductTypeFormat': 'Print Book', 'PromoCode': null, 'ListPriceSubTotal': 316.85 }];
    //document.getElementsByTagName('body')[0].appendChild(this.shoppingService.LoadGoogleAnalyticScripts());
    this.ShowDiscount = true;
    this.helperService.observeLoading.subscribe(loadingobj => {
      this.loading = loadingobj;
      });
    this.activatedRoute.queryParams.subscribe(params => {
      const appID = params['appID'];
      const TokenID = params['token'];
      const GUID = params['GUID'];
      const promoCode = params['promoCode'];
      const isLTI = params['isLTI'];
      this.shoppingService.SetDefaultOnLoad(appID, GUID, TokenID, promoCode,isLTI);

      this.shoppingService.IsCartComponent.emit(true);
      this.shoppingService.IsCheckoutComponent.emit(false);

      this.Token = this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage);
      this.isLTI =  this.helperService.getFromLocalStorage(appVariables.isLTI);

      if (this.Token) {
        this.shoppingService.IsLoggedIn.emit(true);
        this.shoppingService.setToken(this.Token);
        this.user.tokenFromUser = this.Token;
        this.shoppingService.logIn(this.user)
          .subscribe(
            (response) => {
              this.helperService.setUserToLocalStorage(response.Data);
              this.shoppingService.LoggedInDetails.emit(response.Data);
              this.fromLocal = this.helperService.getUserFromLocalStorage();
              this.shoppingService.setToken(this.fromLocal['token']);
              if (this.helperService.getFromLocalStorage(appVariables.displaySection) === '') {
                this.shoppingService.setDisplaySection('Login');
              }
              document.getElementsByTagName('body')[0].appendChild(this.shoppingService.LoadScript(response));
            },
            (error) => { }
          );
      }
      this.loadItems();
    });
    // this.Token = this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage) != null ?
    //   this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage) : '';
    // this.loadItems();
    this.shoppingService.observeCartItems.subscribe(cartItemsList => {
      this.CartItemsList = cartItemsList;
      if (this.CartItemsList.length > 0) {
        this.CartItemsList = this.CartItemsList.sort(function (a, b) {
          return a.ProductID > b.ProductID ? 1 : a < b ? -1 : 0;
        });
        this.TotalQuantity = 0;
        this.CartSubtotal = 0;
        this.ShowDiscount = false;
        for (let i = 0; i < this.CartItemsList.length; i++) {
          // if (this.CartItemsList[i].ImageUrl) {
          //   this.CartItemsList[i].ImageUrl = this.CartItemsList[i].ImageUrl;
          //   // && !this.CartItemsList[i].ImageUrl.includes(this.ImageUrl)   this.ImageUrl +
          // }
          if (this.CartItemsList[i].DiscountPercent && Number(this.CartItemsList[i].DiscountPercent) > 0) {
            this.ShowDiscount = true;
          }
          this.TotalQuantity += Number(this.CartItemsList[i].Quantity);
          this.CartSubtotal = Number(this.CartItemsList[i].CartSubtotal.replace(',', ''));
          this.ShippingMessage = this.CartItemsList[i].ShippingMessage;
          this.ShippingCharge = this.CartItemsList[i].ShippingCharge;
          this.enableProductLimitMsg[this.CartItemsList[i].ProductID] = false;
        }
      }
      this.isDisabled = this.TotalQuantity <= 0;
    });


    this.shoppingService.observeBackToPageUrl.subscribe(appurl => {
      this.BackToPageUrl = appurl;
    });
    this.DigitalProductNote = appMessages.DigitalProductNote;
    this.isLTIProductChekoutMsg = appMessages.isLTIProductChekoutMsg;
  }

  OnEmptyShoppingCart() {
    this.clear();
    this.shoppingService.RemoveAllItemsFromAPI(this.helperService.getFromLocalStorage(appVariables.cartGUID))
      .subscribe(
        (response: Response) => {
          this.ShowDiscount = false;
          this.helperService.setToLocalStorage(appVariables.promoCode, '');

          this.loadItems();
        },
        (error) => {
          this.HandleError(error);

        }
      );
  }

  OnRemoveClick(CartItemsList: CartItemsModel) {
    this.clear();
    this.shoppingService.RemoveItemsFromAPI(CartItemsList.ProductID.toString(),
      this.helperService.getFromLocalStorage(appVariables.cartGUID))
      .subscribe(
        (response: Response) => {
          delete (this.enableProductLimitMsg[CartItemsList.ProductID]);//removed unwanted key and update all the Object to there defaut values
          setTimeout(() => {
            this.loadItems();
          });
        },
        (error) => {
          this.HandleError(error);

        }
      );
  }
  OnUpdateClick(CartItemsList: CartItemsModel) {
    this.clear();
    // tslint:disable-next-line:max-line-length
    this.shoppingService.UpdateItemsFromAPI(CartItemsList.ProductID.toString(),
      CartItemsList.Quantity.toString(), this.helperService.getFromLocalStorage(appVariables.cartGUID))
      .subscribe(
        (response: Response) => {
          this.enableProductLimitMsg[CartItemsList.ProductID] = false;//FAD-817 fix
          setTimeout(() => {
            this.loadItems();
          });
        },
        (error) => {
          this.HandleError(error);

        }
      );
  }
  clear() {
    this.ErroMessage = [];
    this.PromoCodeDisplay = { 'Message': '', 'class': 'redcolor' };
    //  localStorage.setItem(appVariables.promoCode, '');
  }
  HandleError(error) {
    this.ErroMessage = [appMessages.CommonError]; // JSON.parse(error._body).Error;
  }
  setDefaultPic(cartitems) {
    cartitems.ImageUrl = environment.defaultProductImage; // 'assets/images/my-image.png';
  }

  setParentPic(cartitems) {
    let isbn = '';
    this.shoppingService.GetParentProductImageFromAPI(cartitems.ProductID, isbn)
      .subscribe(
        (response) => {
          cartitems.ImageUrl = response.Data;
        },
        (error) => {
          // .status === 401
          if (error) {

          }
        }
      );
  };
  // -----------------------------------------------------------------------
  uploadFileToActivity() {
    this.postFile()
      .subscribe(data => {
        // do something, if upload success
      }, error => {
      });
  }

  postFile(): Observable<any> {
    const endpoint = 'https://dtestsecureservices.fadavis.com:443/ShoppingCart/api/ShoppingCart/LoadShoppingCartItems';
    this.headers = new Headers();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('appId', '5');
    const options = new RequestOptions({
      headers: this.headers
    });

    const body = {
      // 'AccountID': 0,
      'PromoCode': '',
      'ShoppingCartGUID': '30DCD94B-6D4F-4F99-9D66-A69C95926D72',
      // 'ProductID': 0,
      // 'Quantity': 0,
      // 'ShoppingCartID': 0,
      // 'ProductIDs': 'string'
    };

    return this.http
      .post(endpoint, body, options);
  }

  private handleError(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.message || error);
  }

  OnAddtoCartUpsellProduct(ProductID: number) {
    this.clear();

    this.fromLocal = this.helperService.getUserFromLocalStorage();
    if (this.fromLocal['AccountID'] != null) {
      this.accountID = this.fromLocal['AccountID'];
    }
    else {
      this.accountID = 0;
    }
    this.fromLocal = this.helperService.getUserFromLocalStorage();
    if (this.fromLocal['token'] == null) {
      this.token = '';
    }
    else {
      this.token = this.fromLocal['token'];
    }
    this.shoppingService.OnAddUpsellProductToCart(parseInt(this.helperService.getFromLocalStorage(appVariables.accessAppID)), ProductID, this.quantity, this.helperService.getFromLocalStorage(appVariables.cartGUID), this.accountID, this.token)
      .subscribe(
        (response: Response) => {
          setTimeout(() => {
            this.loadItems();
          });
        },
        (error) => {
          this.HandleError(error);

        }
      );

  }
  /*Comment by:Shorya Saxena
    Ticket number: FAD-716 
    Function:ShowValidationErrorPopUp
    Desc: will display over limit cart error message list if quantity cross to 3
  */
    ShowValidationErrorPopUp($event: any, item: any, tooltip) {
      if (Number($event.target.value) > overLimitCartDetails.limit
        && (item.ProductTypeFormat.includes('Print Book') || item.ProductTypeFormat.includes('Package'))) {
        item.Quantity = overLimitCartDetails.limit;
        $event.target.value = `${overLimitCartDetails.limit}`;
        this.enableProductLimitMsg[item.ProductID] = true;
       tooltip.open();
      } else {
        item.Quantity = $event.target.value;
        this.enableProductLimitMsg[item.ProductID] = false;
        if (tooltip.isOpen()) {
         tooltip.close();
        } 
      }
    }
  RedirectFADPage(ProductID: number) {
    this.clear();
    this.FADBaseUrl = environment.FADBaseUrl;
    for (let item of this.CartItemsList) {
      if (item.ProductID === ProductID) {
        this.RedirectProductURL = item.RedirectProductURL;
        if (this.RedirectProductURL !== " ") {
          this.RedirectProductdetailURL = this.FADBaseUrl + 'product/' + this.RedirectProductURL;
          window.open(this.RedirectProductdetailURL, "_blank");
        }
        else {
          this.RedirectProductdetailURL = this.FADBaseUrl;
          window.open(this.RedirectProductdetailURL, "_blank");
        }

      }
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/cart/cart.component.ts